if (!customElements.get("table-drawer")) {
  class TabelDrawer extends HTMLElement {
    constructor() {
      super(), this.addListeners();
    }
    addListeners() {
      this.querySelector(".js-table-drawer").addEventListener(
        "click",
        TabelDrawer.handleOpenDrawer,
      );
    }
    static handleOpenDrawer(evt) {
      if (!evt.target.classList.contains("variant-selector")) {
        const tableDrawer = evt.target.closest(".js-table-drawer");
        document
          .getElementById(`table-${tableDrawer.dataset.id}-drawer`)
          .open();
      }
    }
  }
  customElements.define("table-drawer", TabelDrawer);
}
